"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
exports.generateErrors = function (errors) {
    if (!errors || errors.length === 0) {
        return {};
    }
    return errors.reduce(function (accumulatedErrors, currentError) {
        return (currentError.errors || []).reduce(function (acc, curr) {
            var _a, _b;
            var model = curr.model, field = curr.field, code = curr.code;
            var fieldName = [model, field].filter(Boolean).join('.');
            var errorName = fieldName + "." + code;
            return acc.hasOwnProperty(fieldName)
                ? __assign({}, acc, (_a = {}, _a[fieldName] = __assign({}, acc[fieldName], { errors: acc[fieldName].errors.concat([new Error(errorName)]), codes: acc[fieldName].codes.concat([code]) }), _a)) : __assign({}, acc, (_b = {}, _b[fieldName] = {
                errors: [new Error(errorName)],
                codes: [code],
            }, _b));
        }, accumulatedErrors);
    }, {});
};
exports.generateFormErrors = function (errors, values, _a) {
    var i18nPrefix = _a.i18nPrefix, formatMessage = _a.formatMessage;
    return Object.keys(errors).reduce(function (outputErrors, currentErrorKey) {
        var _a;
        var formattedErrors = errors[currentErrorKey].errors.map(function (err) {
            return new Error(formatMessage({ id: i18nPrefix + "." + err.message }));
        });
        return __assign({}, outputErrors, (_a = {}, _a[currentErrorKey] = __assign({}, errors[currentErrorKey], { value: lodash_1.get(values, currentErrorKey), errors: formattedErrors }), _a));
    }, {});
};
exports.handleSideEffectErrors = function (errors, handlers) {
    return handlers.some(function (handler) {
        var errorKey = Object.keys(handler)[0];
        if (!errors[errorKey]) {
            return false;
        }
        var errorHandlerFn = handler[errorKey];
        var relevantError = errors[errorKey];
        return errorHandlerFn(relevantError);
    });
};
//# sourceMappingURL=error.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-fns/dist/error/error.js
// module id = 1379
// module chunks = 0